import React, { useState, useEffect, useContext } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";

import { VentasContext } from "../VentasMain";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { FiltroSolicitudesCerradas } from "./Filtros/FiltroSolicitudesCerradas";

export const ListadoSolicitudesCerradasScreen = () => {
    const location = useLocation();
    const history = useHistory();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const { state, setState } = useContext(VentasContext);
    const [solicitudes, setSolicitudes] = useState({
        tablero: [],
        tabla: [],
        vendedores: [],
        sucursales: [],
    });
    const [filtroAbierto, setFiltroAbierto] = useState(false);


    // Obtener filtros del estado de la ubicación
    const filtrosIniciales = location.state?.filtros || {
        folio: "",
        asesor: "",
        razon_social: "",
        sucursal: "",
        estado: "",
        tipo_solicitud: ""
    };

    // Filtros
    const [filtroRazonSocial, setFiltroRazonSocial] = useState(filtrosIniciales.razon_social);
    const [filtroTipoSolicitud, setFiltroTipoSolicitud] = useState(filtrosIniciales.tipo_solicitud);
    const [filtroLineaCredito, setFiltroLineaCredito] = useState([]);
    const [filtroEstado, setFiltroEstado] = useState(filtrosIniciales.estado);
    const [filtroSucursal, setFiltroSucursal] = useState(filtrosIniciales.sucursal);
    const [filtroVendedor, setFiltroVendedor] = useState(filtrosIniciales.asesor);
    const [filtroFolio, setFiltroFolio] = useState(filtrosIniciales.folio);

    //Location
    useEffect(() => {
        //si locatopn tiene propirdad
        //lanzar onOpenSolicitud(foliomnombrecliente)
        //return 
        if (location.state !== undefined) {
            if (location.state.folio !== undefined && location.state.folio !== null && location.state.folio !== "") {
                onOpenSolicitud(location.state.folio, location.state.cliente)
                return
            }

        }

        setLoader({ ...loader, mostrar: true });
        request
            .get(`SolicitudesCerradas/GetTablero`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setSolicitudes({
                    tablero: result.tablero,
                    tabla: result.tablero,
                    vendedores: result.vendedor,
                    sucursales: result.sucursal,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SOLICITUDES DE CREDITO", JSON.stringify(error), "error");
            });
    }, []);

    useEffect(() => {
        if (solicitudes.tablero.length > 0) {
            onFiltrar(filtroFolio, filtroVendedor, filtroRazonSocial, filtroSucursal, filtroEstado, filtroTipoSolicitud);
        }
    }, [solicitudes.tablero]);

    // const onOpenSolicitud = (folio, cliente) => {
    //     // Actualiza el estado global con los filtros actuales y otros detalles
    //     setState(prevState => ({
    //         ...prevState,
    //         filtros: {
    //             folio: filtroFolio,
    //             asesor: filtroVendedor,
    //             razon_social: filtroRazonSocial,
    //             sucursal: filtroSucursal,
    //             estado: filtroEstado,
    //             tipo_solicitud: filtroTipoSolicitud,
    //         },
    //         folio,
    //         cliente,
    //     }));

    //     // Redirige a la página de detalle de la solicitud
    //     history.push("/Ventas/SolicitudesCerradasTimeline");
    // };

    const onOpenSolicitud = (folio, cliente) => {
        history.push("/SolicitudCredito/Main", {
            folio: folio,
            cliente: cliente,
            direccion: "V",
            redireccion:"/Ventas/SolicitudesCerradas",
            filtros: {
                folio: filtroFolio,
                asesor: filtroVendedor,
                razon_social: filtroRazonSocial,
                sucursal: filtroSucursal,
                estado: filtroEstado,
                tipo_solicitud: filtroTipoSolicitud,
            },
        });
    };

    const onFiltrar = (
        folio,
        asesor,
        razon_social,
        sucursal,
        estado,
        tipo_solicitud,
        linea_credito,
    ) => {
        return new Promise((resolve, reject) => {
            var newtabla = solicitudes.tablero;

            // Aplicar filtros a la tabla
            if (folio != undefined && folio !== null && folio != "") {
                newtabla = newtabla.filter((item) => item.folio === folio);
            } else {
                if (asesor != undefined && asesor !== null && asesor != "") {
                    newtabla = newtabla.filter((item) => item.vendedor === asesor);
                }
                if (razon_social != undefined && razon_social !== null && razon_social != "") {
                    newtabla = newtabla.filter((item) => item.razon_social === razon_social);
                }
                if (sucursal != undefined && sucursal !== null && sucursal != "") {
                    newtabla = newtabla.filter((item) => item.sucursal === sucursal);
                }
                if (estado != undefined && estado !== null && estado != "") {
                    newtabla = newtabla.filter((item) => item.estado === estado);
                }
                if (tipo_solicitud != undefined && tipo_solicitud !== null && tipo_solicitud != "") {
                    newtabla = newtabla.filter((item) => item.tipo_credito === tipo_solicitud);
                }
                if (linea_credito != undefined && linea_credito !== null && linea_credito != "") {
                    newtabla = newtabla.filter((item) => item.linea_credito === linea_credito);
                }
            }

            // Actualiza la tabla en el estado local
            setSolicitudes({ ...solicitudes, tabla: newtabla });
            resolve("");
            return;
        });
    };

    const RazonSocial = Array.from(
        new Set(solicitudes.tablero.map((item) => item.razon_social))
    );

    const TipoSolicitud = Array.from(
        new Set(solicitudes.tablero.map((item) => item.tipo_credito))
    );

    const LineaCredito = Array.from(
        new Set(solicitudes.tablero.map((item) => item.linea_credito))
    );

    const Estado = Array.from(
        new Set(solicitudes.tablero.map((item) => item.estado))
    );

    const Sucursal = Array.from(
        new Set(solicitudes.tablero.map((item) => item.sucursal))
    );

    const Vendedor = Array.from(
        new Set(solicitudes.tablero.map((item) => item.vendedor))
    );

    const Folio = Array.from(
        new Set(solicitudes.tablero.map((item) => item.folio))
    );

    const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const resetFiltros = () => {
        setFiltroRazonSocial([]);
        setFiltroTipoSolicitud([]);
        setFiltroLineaCredito([]);
        setFiltroEstado([]);
        setFiltroSucursal([]);
        setFiltroVendedor([]);
    };

    const modalContent = (
        <div className="filtro">
            <div className="head-filtro">
                <div className="titulo-filtrar">
                    ESTADO DE SOLICITUD DE CREDITO
                    <span className="cerrar-modal" onClick={handleCloseModal}>
                        X
                    </span>
                </div>
            </div>
            <div className="dash-presentacion-titulo-barras">
                <div className="dash-presentacion-bl"></div>
                <div className="dash-presentacion-circle"></div>
                <div className="dash-presentacion-br"></div>
            </div>

            <div className="filtro-container">
                <div className="modal-container-row-dropdownlist">
                    <div className="vendedor-container">
                        <div className="filtros-subtitles">VENDEDOR</div>
                        <select
                            className={`filtro-dropdownlist ${filtroVendedor
                                ? "filtro-dropdownlist-selected"
                                : "filtro-dropdownlist"
                                }`}
                            value={filtroVendedor}
                            onChange={(e) => setFiltroVendedor(e.target.value)}
                        >
                            <option value="">Selecciona un vendedor</option>
                            {Vendedor.map((vendedor) => (
                                <option key={vendedor} value={vendedor}>
                                    {vendedor}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="razon-social-container">
                        <div className="filtros-subtitles">Razon Social</div>
                        <select
                            className={`filtro-dropdownlist ${filtroRazonSocial
                                ? "filtro-dropdownlist-selected"
                                : "filtro-dropdownlist"
                                }`}
                            value={filtroRazonSocial}
                            onChange={(e) => setFiltroRazonSocial(e.target.value)}
                        >
                            <option value="">Selecciona una razón social</option>
                            {RazonSocial.map((razon_social) => (
                                <option key={razon_social} value={razon_social}>
                                    {razon_social}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="modal-container-row-dropdownlist">
                    <div className="sucursal-container">
                        <div className="filtros-subtitles">SUCURSAL</div>
                        <select
                            className="filtro-dropdownlist"
                            value={filtroSucursal}
                            onChange={(e) => setFiltroSucursal(e.target.value)}
                        >
                            <option value="">Selecciona una sucursal</option>
                            {Sucursal.map((sucursal) => (
                                <option key={sucursal} value={sucursal}>
                                    {sucursal}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <div className="filtros-subtitles">ESTADO</div>
                        <select
                            className="filtro-dropdownlist"
                            value={filtroEstado}
                            onChange={(e) => setFiltroEstado(e.target.value)}
                        >
                            <option value="">Selecciona un estado</option>
                            {Estado.map((estado) => (
                                <option key={estado} value={estado}>
                                    {estado}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="modal-container-row-dropdownlist">
                    <div>
                        <h3 className="filtros-subtitles">Tipo de solicitud</h3>
                        <select
                            className="filtro-dropdownlist"
                            value={filtroTipoSolicitud}
                            onChange={(e) => setFiltroTipoSolicitud(e.target.value)}
                        >
                            <option value="">Selecciona el tipo de solicitud</option>
                            {TipoSolicitud.map((tipo_credito) => (
                                <option key={tipo_credito} value={tipo_credito}>
                                    {tipo_credito}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <h3 className="filtros-subtitles">LINEA DE CREDITO</h3>
                        <select
                            className="filtro-dropdownlist"
                            value={filtroLineaCredito}
                            onChange={(e) => setFiltroLineaCredito(e.target.value)}
                        >
                            <option value="">Selecciona el tipo de linea</option>
                            {LineaCredito.map((linea_credito) => (
                                <option key={linea_credito} value={linea_credito}>
                                    {linea_credito}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="boton-restablecer" onClick={resetFiltros}>
                RESTABLECER
            </div>

        </div>
    );


    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };

    // Contador de solicitudes visibles
    const numeroDeSolicitudes = solicitudes.tabla.length;


    return (
        <PlantillaScreen
            titulo={" SOLICITUDES DE OPERACION CERRADAS"}
            className={"facturacion-maquinaria-main-screen"}
            className_main={1}
        >
            <div className="analisis-solicitud-credito-cerradas">
                <LoaderScreen loader={loader} />


                {solicitudes.tablero === undefined ||
                    solicitudes.tablero === null ||
                    solicitudes.tablero.length === 0 ? (
                    <div></div>
                ) : (
                    <div className="analisis-solicitud-credito-container">
                        <div className="analisis-solicitud-credito-container-filtros">

                            <FiltroSolicitudesCerradas
                                tablero={solicitudes.tablero}
                                filtroRazonSocialB={filtroRazonSocial}
                                setFiltroRazonSocialB={setFiltroRazonSocial}
                                filtroTipoSolicitudB={filtroTipoSolicitud}
                                setFiltroTipoSolicitudB={setFiltroTipoSolicitud}
                                filtroLineaCreditoB={filtroLineaCredito}
                                setFiltroLineaCreditoB={setFiltroLineaCredito}
                                filtroEstadoB={filtroEstado}
                                setFiltroEstadoB={setFiltroEstado}
                                filtroSucursalB={filtroSucursal}
                                setFiltroSucursalB={setFiltroSucursal}
                                filtroVendedorB={filtroVendedor}
                                setFiltroVendedorB={setFiltroVendedor}
                                setFiltroFolioB={setFiltroFolio}
                                filtroFolioB={filtroFolio}
                                onFiltrar={onFiltrar}
                            />

                            <Modal open={openModal} onClose={handleCloseModal}>
                                {modalContent}
                            </Modal>
                            <div className="contador-solicitudes">
                                Número de operaciones: {numeroDeSolicitudes}
                            </div>
                        </div>
                        <div className="analisis-solicitud-credito-container-table scroll-4">
                            <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr className="tr-columnas">
                                        <th>Sucursal</th>
                                        <th>
                                            <div>Cliente</div>
                                        </th>
                                        <th>
                                            <div>Asesor de Venta</div>
                                        </th>
                                        <th>
                                            <div>Tipo de Solicitud</div>
                                        </th>
                                        <th>
                                            <div>Linea</div>
                                        </th>
                                        <th>
                                            <div>Vendedor</div>
                                        </th>
                                        <th>
                                            <div>Fecha</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {solicitudes.tabla.map((item) => (
                                        <tr
                                            onClick={() =>
                                                onOpenSolicitud(item.folio, item.razon_social)
                                            }
                                        >
                                            <td>{capitalizeWords(item.sucursal)}</td>
                                            <td>{capitalizeWords(item.razon_social)}</td>
                                            <td>{item.vendedor}</td>
                                            <td>{capitalizeWords(item.tipo_credito)}</td>
                                            <td>{capitalizeWords(item.linea_credito)}</td>
                                            <td>{item.vendedor}</td>
                                            <td>{item.fecha}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </PlantillaScreen>
    );
};
